import { useLazyQuery, useQuery } from "@apollo/client";
import { SHOP } from "../shops.queries";
import {
  ShopQuery,
  ShopQueryVariables,
} from "../../../__generated__/ShopQuery";

export const useShop = (id: number) => {
  return useQuery<ShopQuery, ShopQueryVariables>(SHOP, {
    variables: { id },
  });
};

export const useLazyShop = () => {
  return useLazyQuery<ShopQuery, ShopQueryVariables>(SHOP);
};
